import { render, staticRenderFns } from "./ConfigDocExoplayerJava.vue?vue&type=template&id=0f42a556&scoped=true&"
import script from "./ConfigDocExoplayerJava.vue?vue&type=script&lang=js&"
export * from "./ConfigDocExoplayerJava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42a556",
  null
  
)

export default component.exports